var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCandlesticksChart = function SvgCandlesticksChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.5 3H15v2h2v8.5h-2v4h-1.5v-4h-2V5h2zm-.5 9V6.5h2.5V12zM5 6h1.5v2h2v7.5h-2v2H5v-2H3V8h2zm-.5 8V9.5H7V14z",
    clipRule: "evenodd"
  })));
};
export { SvgCandlesticksChart as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTMuNSAzSDE1djJoMnY4LjVoLTJ2NGgtMS41di00aC0yVjVoMlYzWm0tLjUgOVY2LjVoMi41VjEySDEzWk01IDZoMS41djJoMnY3LjVoLTJ2Mkg1di0ySDNWOGgyVjZabS0uNSA4VjkuNUg3VjE0SDQuNVoiIC8+Cjwvc3ZnPg==";